module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-156.94898b07.jpg";